import type { TeamType } from '../../typings/enums';

export const ProjectTypeOptions = [
  'container',
  'archive',
  'provided',
  'autobuild',
  'sbom',
  'binary',
] as const;

export type ProjectType = typeof ProjectTypeOptions[number];

export enum ProjectCategory {
  Projects = 'projects',
  ReleaseGroups = 'releaseGroups',
  SharedProjects = 'sharedProjects',
}

export const ProjectCategoryName: Record<ProjectCategory, string> = {
  [ProjectCategory.Projects]: 'project',
  [ProjectCategory.ReleaseGroups]: 'release group',
  [ProjectCategory.SharedProjects]: 'shared project',
} as const;

export type ProjectTeam = {
  id: number;
  name: string;
  uniqueId: string | null;
  teamType: TeamType;
};

// Type that reflects how LatestRevision data is returned
// by ProjectsV2, where the locator is always present
export type LatestRevision = {
  locator: string;
  message?: string;
};

export type ProjectIssues = {
  total: number | null;
  licensing: number | null;
  security: number | null;
  quality: number | null;
};

export type ProjectId = string;

export type ProjectLabels = string[];

/**
 * When deleting all projects from an org and there are 100 <= n < 1000 projects, the number of days to spread the project deletions across.
 */
export const OVER_100_PROJECTS_SPREAD_DAYS = 1;

/**
 * When deleting all projects from an org and there are >1000 projects, the number of days to spread the project deletions across.
 */
export const OVER_1_000_PROJECTS_SPREAD_DAYS = 7;
